module.exports = {
      id: "pause-usage",
      viewBox: "0 0 31 30",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#pause",
      toString: function () {
        return this.url;
      }
    }